export const IconCheckCorrect40: {
  name: 'icon_check_correct_40-8bfaa67f9f2b'
} = {
  name: 'icon_check_correct_40-8bfaa67f9f2b'
}
